"use client";

import { useEffect, useState } from "react";
import { VeicoloData } from "@/interface/VeicoloData";

interface StoredCartState {
    vehicles: VeicoloData[];
}

const EMPTY_CART: StoredCartState = { vehicles: [] };

function readStoredCart(): StoredCartState {
    if (typeof window === "undefined") {
        return EMPTY_CART;
    }

    try {
        const rawCart = window.localStorage.getItem("cart");
        if (!rawCart) {
            return EMPTY_CART;
        }

        const parsed = JSON.parse(rawCart) as StoredCartState;
        return Array.isArray(parsed?.vehicles) ? parsed : EMPTY_CART;
    } catch {
        return EMPTY_CART;
    }
}

export function useStoredCart() {
    const [vehicles, setVehicles] = useState<VeicoloData[]>([]);

    useEffect(() => {
        const syncCart = () => {
            setVehicles(readStoredCart().vehicles);
        };

        syncCart();
        window.addEventListener("storage", syncCart);
        window.addEventListener("cart-updated", syncCart as EventListener);

        return () => {
            window.removeEventListener("storage", syncCart);
            window.removeEventListener("cart-updated", syncCart as EventListener);
        };
    }, []);

    return {
        vehicles,
        count: vehicles.length,
    };
}
